<template>
    <v-container id="DetalleReporte">
        <div v-if="show == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-layout row wrap>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color:transparent !important;" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Datos Generales </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-file-document</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Etapa: " :subtitle="this.detalleReporteData.etapa"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Número de Póliza:"
                                    :subtitle="this.detalleReporteData.dapoliza"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Titular:"
                                    :subtitle="this.detalleReporteData.svnomcond"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Número de Siniestro:"
                                    :subtitle="this.detalleReporteData.svnumsin"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Persona:"
                                    :subtitle="this.detalleReporteData.persona"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Cliente:"
                                    :subtitle="this.detalleReporteData.clnombre"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Flotilla:"
                                    :subtitle="this.detalleReporteData.flnomcorto"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Gestor:"
                                    :subtitle="this.detalleReporteData.prnombrecorto"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Ejecutivo:"
                                    :subtitle="this.detalleReporteData.usnom"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card style="background-color:transparent !important;" width="100%">
                        <v-card flat class="text-xs-center ma-3">
                            <v-card-title class="justify-center primary">
                                <v-toolbar-title id="titulocard">Datos del Siniestro</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-icon>mdi-map-marker-radius</v-icon>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <vs-list>
                                    <vs-list-item title="Estado:"
                                        :subtitle="this.detalleReporteData.esnombre"></vs-list-item>
                                </vs-list>
                                <vs-list>
                                    <vs-list-item title="Localidad:"
                                        :subtitle="this.detalleReporteData.lonombre"></vs-list-item>
                                </vs-list>
                                <vs-list-item subtitle="Robo: ">
                                    <v-checkbox disabled v-model="this.svrobo" style="margin:0px;"></v-checkbox>
                                </vs-list-item>
                                <vs-list-item subtitle="Colisión: ">
                                    <v-checkbox disabled v-model="this.svcolision" style="margin:0px;"></v-checkbox>
                                </vs-list-item>
                                <vs-list-item subtitle="Robo Recuperado: ">
                                    <v-checkbox disabled v-model="this.svacredp" style="margin:0px;"></v-checkbox>
                                </vs-list-item>
                            </v-card-text>
                        </v-card>
                    </v-card>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color:transparent !important;" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Asistencia</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-information-outline</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item :subtitle="this.detalleReporteData.ainombre"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Datos del Vehiculo </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-car-info</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Serie: "
                                    :subtitle="this.detalleReporteData.svserie"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Marca: "
                                    :subtitle="this.detalleReporteData.svmarca"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Modelo: "
                                    :subtitle="this.detalleReporteData.svmodelo"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Año: " :subtitle="this.detalleReporteData.svanio"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Color: "
                                    :subtitle="this.detalleReporteData.svcolor"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Placas: " :subtitle="detalleReporteData.svplaca"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Datos Contacto</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-card-account-phone</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <v-list-item-title class="vs-list--title">
                                    Email
                                </v-list-item-title>

                                <div v-if="!editEmail">
                                    <v-btn icon x-small v-if="permisoEdit == 1" @click="editarCorreo()" title="Editar">
                                        <v-icon small>mdi-lead-pencil</v-icon>
                                    </v-btn>

                                    <span style="color: black; font-size: 20px; text-align: center;">
                                        {{ detalleReporteData.svemail }}</span>
                                </div>
                                <v-row v-if="editEmail">
                                    <v-btn icon @click="guardarEmail()" title="Guardar" :disabled="disabledSaveEmail">
                                        <v-icon small>mdi-content-save</v-icon>
                                    </v-btn>
                                    <v-btn icon @click="cancelarEmail()" title="Cancelar" :disabled="disabledSaveEmail">
                                        <v-icon small>mdi-keyboard-return</v-icon>
                                    </v-btn>
                                </v-row>
                                <v-col md="12" v-if="editEmail">
                                    <v-form ref="form2" v-model="valid2" lazy-validation>
                                        <v-text-field v-model="svemail" outlined :rules="rulesemail" dense
                                            style="margin-bottom: 0px;"></v-text-field>
                                        <span v-if="validamismoemail" class='spanError'
                                            style='color:red;font-size:11px'>Modifique el texto del Email</span>
                                    </v-form>
                                </v-col>
                            </vs-list>

                            <v-form ref="form1" v-model="valid1" lazy-validation>
                                <vs-list v-for="(item, index) in telefonos" :key="index">
                                    <v-list-item-content v-if="item.showEditar == 0">
                                        <v-list-item-title class="vs-list--title">
                                            {{ item.stadescripcion }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            <vs-col vs-lg="7" style="margin-top: 5px;">
                                                <v-icon color="indigo">{{ item.icon }} </v-icon>
                                                <v-btn icon title="Copiar" color="pink" v-if="permisoIVR">
                                                    <v-icon @click="LlamadaIVR(item, 2);"
                                                        small>mdi-content-copy</v-icon>
                                                </v-btn>
                                                <span v-if="permisoIVR"
                                                    style="color: black; font-size: 16px; text-align: center;"
                                                    v-on:click="LlamadaIVR(item, 1)"> {{ item.Column1
                                                    }}
                                                    {{ item.stnumero }}</span>
                                                <span v-else style="color: black; font-size: 16px; text-align: center;">
                                                    {{ item.Column1 }} {{ item.stnumero }}</span>
                                            </vs-col>
                                            <vs-col vs-lg="2" style="margin-top: 5px;">
                                            </vs-col>
                                            <vs-col vs-lg="2" vs-align="right"
                                                v-if="showEditar && !showAgregar && permisoTelf == 1 && validaConclusion">
                                                <v-btn icon @click="editaTelf(item, index)" title="Editar"
                                                    color="indigo">
                                                    <v-icon small>mdi-lead-pencil</v-icon>
                                                </v-btn>
                                                <v-btn icon @click="eliminaTelf(item, index)" title="Eliminar"
                                                    color="red">
                                                    <v-icon small>mdi-delete</v-icon>
                                                </v-btn>
                                            </vs-col>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>

                                    <!--<v-list-item-content v-if="item.showEditar == 0">
            <v-list-item-title class="vs-list--title">
                {{item.stadescripcion}}
            </v-list-item-title>
            <v-list-item-subtitle class="row-pointer vs-list--subtitle">
                <span v-on:click="LlamadaIVR(item.stconsecutivotel)">{{item.Column1}} {{item.stnumero}}</span>

                <v-tooltip left>
                    <template v-slot:activator="{ on}">
                        <v-icon v-on="on" v-text="item.icon"></v-icon>
                    </template>
<span v-text="item.sttdescripcion"></span>
</v-tooltip>
<v-tooltip left v-if="permisoTelf == 1">
    <template v-slot:activator="{ on}">
                        <v-btn icon
                               @click="editaTelf(item,index)"
                               title="Editar"
                               color="indigo">
                            <v-icon small>mdi-lead-pencil</v-icon>
                        </v-btn>
                    </template>
</v-tooltip>
<v-tooltip left v-if="permisoTelf == 1">
    <template v-slot:activator="{ on}">
                        <v-btn icon
                               @click="eliminaTelf(item,index)"
                               title="Eliminar"
                               color="red">
                            <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                    </template>
</v-tooltip>
</v-list-item-subtitle>
</v-list-item-content>-->

                                    <v-col md="12" v-if="item.showEditar == 1">

                                        <span style="color: black; text-align: center;">Actor:</span>
                                        <multiselect v-model="actores.staid"
                                            deselect-label="No se puede remover el valor seleccionado"
                                            selected-label="Seleccionado" track-by="staid" label="stadescripcion"
                                            placeholder="" :options="actores.opcionesActores" :allow-empty="false">
                                        </multiselect>
                                        <div v-if="validaActor">
                                            <span class='spanError' style='color:red;font-size:11px'>Campo
                                                requerido</span>
                                            <br />
                                        </div>
                                        <!--<v-select v-model="actor"
            :items="opcionesActores"
            outlined
            dense></v-select>-->

                                        <span style="color: black; text-align: center;">Tipo:</span>
                                        <multiselect v-model="tipotelf.sttid"
                                            deselect-label="No se puede remover el valor seleccionado"
                                            selected-label="Seleccionado" track-by="sttid" label="sttdescripcion"
                                            placeholder="" :options="tipotelf.opcionestipotelf" :allow-empty="false">
                                        </multiselect>
                                        <div v-if="validaTipo">
                                            <span class='spanError' style='color:red;font-size:11px'>Campo
                                                requerido</span>
                                            <br />
                                        </div>
                                        <!--<v-select v-model="tipotelf"
            :items="opcionestipotelf"
            outlined
            dense></v-select>-->

                                        <span style="color: black; text-align: center;">Número:</span>

                                        <vue-tel-input-vuetify v-model="numtelf" id="telprueba"
                                            :error-messages="errorTelf" @input="onInput" outlined label=""
                                            autocomplete="off" loading="true" max="10" required placeholder=""
                                            :defaultCountry="item.country" validCharactersOnly="false"
                                            v-on:country-changed="countryChanged" dense></vue-tel-input-vuetify>
                                        <span v-if="validaTelefono" class='spanError'
                                            style='color:red;font-size:11px'>Modifique al menos un dato</span>


                                        <!--<vue-tel-input v-model="numtelf"
            class="mt-0 mb-2"></vue-tel-input>-->


                                        <v-row justify="end">
                                            <v-btn icon class="ma-1" @click="guardarEdicion(item, index)"
                                                title="Guardar" color="primary" :disabled="disabledSave">
                                                <v-icon>mdi-content-save</v-icon>
                                            </v-btn>
                                            <v-btn icon class="ma-1" @click="cancelarEdicion(item, index)"
                                                title="Cancelar" color="red" :disabled="disabledSave">
                                                <v-icon>mdi-keyboard-return</v-icon>
                                            </v-btn>
                                        </v-row>
                                    </v-col>


                                </vs-list>
                            </v-form>
                            <v-row justify="end" v-if="valagregar && permisoTelf == 1 && validaConclusion">
                                <v-col align="right">
                                    <v-btn small class="ma-1" title="Agregar Telefono" color="primary"
                                        @click="agregarTelf()">
                                        <v-icon color="white">
                                            mdi-plus
                                        </v-icon>
                                    </v-btn>

                                </v-col>

                            </v-row>

                            <v-col md="12" v-if="showAgregar">

                                <span style="color: black; text-align: center;">Actor:</span>
                                <multiselect v-model="actores.staid"
                                    deselect-label="No se puede remover el valor seleccionado"
                                    selected-label="Seleccionado" track-by="staid" label="stadescripcion" placeholder=""
                                    :options="actores.opcionesActores" :allow-empty="false">
                                </multiselect>
                                <div v-if="validaActor">
                                    <span class='spanError' style='color:red;font-size:11px'>Campo requerido</span>
                                    <br />
                                </div>
                                <!--<v-select v-model="actor"
    :items="opcionesActores"
    outlined
    dense></v-select>-->

                                <span style="color: black; text-align: center;">Tipo:</span>
                                <multiselect v-model="tipotelf.sttid"
                                    deselect-label="No se puede remover el valor seleccionado"
                                    selected-label="Seleccionado" track-by="sttid" label="sttdescripcion" placeholder=""
                                    :options="tipotelf.opcionestipotelf" :allow-empty="false">
                                </multiselect>
                                <div v-if="validaTipo">
                                    <span class='spanError' style='color:red;font-size:11px'>Campo requerido</span>
                                    <br />
                                </div>

                                <!--<v-select v-model="tipotelf"
    :items="opcionestipotelf"
    outlined
    dense></v-select>-->
                                <v-form ref="form" v-model="valid" lazy-validation>
                                    <span style="color: black; text-align: center;">Número:</span>

                                    <vue-tel-input-vuetify v-model="numtelf" @input="onInput"
                                        :error-messages="errorTelf" autocomplete="off" outlined label="" loading="true"
                                        placeholder="" max="10" required defaultCountry="MX" validCharactersOnly="false"
                                        v-on:country-changed="countryChanged" dense></vue-tel-input-vuetify>
                                    <span v-if="validaTelefono" class='spanError'
                                        style='color:red;font-size:11px'>Teléfono inválido</span>
                                </v-form>
                                <!--<vue-tel-input v-model="numtelf"
    class="mt-0 mb-2"></vue-tel-input>-->


                                <v-row justify="end">
                                    <v-btn icon class="ma-1" @click="guardarAlta()" title="Guardar" color="primary"
                                        :disabled="disabledSave">
                                        <v-icon>mdi-content-save</v-icon>
                                    </v-btn>
                                    <v-btn icon class="ma-1" @click="cancelarAlta()" title="Cancelar" color="red"
                                        :disabled="disabledSave">
                                        <v-icon>mdi-keyboard-return</v-icon>
                                    </v-btn>

                                </v-row>
                            </v-col>


                        </v-card-text>
                    </v-card>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color:transparent !important;" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Fechas</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-calendar</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Fecha y hora del siniestro:"
                                    :subtitle="this.detalleReporteData.svfhsiniestro"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Fecha y hora del reporte:"
                                    :subtitle="this.detalleReporteData.svfhreporteaux"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Fecha y hora de asignación:"
                                    :subtitle="this.detalleReporteData.svfhterminoaux"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Fecha y hora conclusión:"
                                    :subtitle="this.detalleReporteData.svfhconclusionaux"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Fecha y hora cerrado:"
                                    :subtitle="this.detalleReporteData.svfhcerrado"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Tipo de Gestoría</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon :color="'#FFFFFF'">mdi-check-circle</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list-item subtitle="Gestoría de indemnización de PT: ">
                                <v-checkbox disabled v-model="this.svalcances" style="margin:0px;"></v-checkbox>
                            </vs-list-item>
                            <vs-list-item subtitle="Simple: ">
                                <v-checkbox disabled v-model="this.svalcancecp" style="margin:0px;"></v-checkbox>
                            </vs-list-item>
                            <vs-list-item subtitle="Compleja: ">
                                <v-checkbox disabled v-model="this.svperdidadc" style="margin:0px;"></v-checkbox>
                            </vs-list-item>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Citas</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon>mdi-calendar-clock</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-row align="center">
                                <v-col cols="12" sm="6">
                                    <h5>Control de Citas</h5>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="text-center">
                                        <v-btn fab dark large color="success" @click="clickCitas">
                                            <v-icon dark>mdi-calendar-clock</v-icon>
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-flex>
        </v-layout>

    </v-container>
</template>
<style>
.row-pointer {
    cursor: pointer;
}
</style>
<script>
import { mapActions, mapState } from 'vuex';
import utils from '@/utils/managerLocalStorage.js';
import Detalle from '@/services/GestoriaDoc/Detalle.service.js';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Contacto from '@/services/DatosDeContacto/DatosContacto.service.js';

export default {
    components: {
    },
    data: function () {
        return {
            //////
            disabledSave: false,
            validaActor: false,
            validaTipo: false,
            valid1: true,
            valid: true,
            validaTelefono: false,
            valagregar: true,
            showAgregar: false,
            showEditar: true,
            rulesphone: [
                val => {
                    //if (val.length != 12) return 'Escriba un telefono válido'
                    return true
                },
                val => /^[0-9\s]+$/g.test(val) || 'Escriba un telefono válido'
            ],
            actores: {
                opcionesActores: [],
                staid: '',
                stadescripcion: ''
            },
            tipotelf: {
                opcionestipotelf: [],
                sttid: '',
                sttdescripcion: ''
            },
            numtelf: '',
            numtelf2: '',
            prefijo: '',
            pais: '',
            telefonos: [],
            detalleReporteData: [],
            svrobo: null,
            svcolision: null,
            svacredp: null,
            show: true,
            permisoTelf: 0,
            validaConclusion: false,
            phone: {
                number: '',
                valid: false,
                country: ''
            },
            errorTelf: [],
            telefonoFormat: null,
            editEmail: false,
            svemail: '',
            valid2: true,
            rulesemail: [
                (val) =>
                    (val && val.length <= 80) ||
                    "Máximo 80 Carácteres",
                val => /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(val) || 'Escriba un Email válido'
            ],
            validamismoemail: false,
            permisoEdit: 0,
            disabledSaveEmail: false,
            permisoIVR: false,
            svalcances: null,
            svalcancecp: null,
            svperdidadc: null
        };
    },

    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    watch: {
        'svemail'() {
            this.validamismoemail = false;
        },

        'numtelf'(val) {

            this.validaTelefono = false;
            this.errorTelf = [];
            //if (val.length == 12 && this.pais == 'MX') {
            //    let dat1 = val.substr(0, 1);
            //    if (dat1 == 0) {

            //        let sec1 = val.substr(1, 2);
            //        let sec2 = val.substr(4, 3);
            //        let sec3 = val.substr(9, 4);


            //        let sec23 = val.substr(8, 1);

            //        this.numtelf = sec1 + ' ' + sec2 + sec23 + ' ' + sec3;
            //    }
            //}

        },
        'actores.staid'(val) {
            this.validaActor = false;
            this.validaTelefono = false;
        },
        'tipotelf.sttid'(val) {
            this.validaTipo = false;
            this.validaTelefono = false;
        },

    },
    async mounted() {
        this.DatosDetalle();
        this.validaConclusion = await MetodosGenerales.getReporteEstatus(this);
    },
    methods: {
        onInput(formattedNumber, { number, valid, country }) {

            this.validaTelefono = false;
            this.telefonoFormat = formattedNumber;


            if (number.input == number.national) {
                this.errorTelf = [];
                this.phone.number = number.national;
                this.phone.valid = valid;
                this.phone.country = country && country.name;
            }
            else {
                this.errorTelf.push("Teléfono Inválido");
                this.phone.number = number.national;
                this.phone.valid = false;
                this.phone.country = country && country.name;
            }

        },
        editarCorreo() {
            this.editEmail = true;
            this.svemail = this.detalleReporteData.svemail;
            this.disabledSaveEmail = false;
        },
        cancelarEmail() {
            this.editEmail = false;
            this.validamismoemail = false;
        },
        guardarEmail() {
            this.disabledSaveEmail = true;
            this.$refs.form2.validate();
            if (this.$refs.form2.validate()) {
                if (this.svemail == this.detalleReporteData.svemail) {
                    this.validamismoemail = true;
                    this.disabledSaveEmail = false;
                }
                else {

                    this.$swal({
                        position: 'center',
                        title: 'Actualizando Email, espere un momento....',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });
                    Detalle.actualizarEmail(this).then(response => {

                        this.$swal.close();
                        if (this.svemail == response[0][0]) {

                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se actualizó el contacto con éxito.',
                                showConfirmButton: true,
                                timer: 3000
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.detalleReporteData.svemail = response[0][0];
                                    this.editEmail = false;
                                    this.validamismoemail = false;
                                    this.disabledSaveEmail = false;
                                }
                            })
                            this.detalleReporteData.svemail = response[0][0];
                            this.editEmail = false;
                            this.validamismoemail = false;
                            this.disabledSaveEmail = false;




                        }



                    });
                }
            }
            else {
                this.disabledSaveEmail = false;
            }
        },
        countryChanged(country) {
            this.prefijo = country.dialCode;
            this.pais = country.iso2;
        },
        guardarEdicion(item, index) {



            this.disabledSave = true;


            this.$refs.form1.validate();


            if (this.actores.staid != '' && this.tipotelf.sttid != '' && this.$refs.form1.validate() && this.prefijo != '' && this.phone.valid == true) {
                const stringWithoutNumbers = this.phone.number.replace(/[^0-9]+/g, "");
                this.numtelf2 = stringWithoutNumbers;
                if (this.numtelf2.toString() != item.stnumero || this.actores.staid.staid != item.staid || this.tipotelf.sttid.sttid != item.sttid) {

                    this.$swal({
                        position: 'center',
                        title: 'Actualizando Contacto, espere un momento....',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });
                    Detalle.actualizarContacto(this, item).then(response => {


                        this.$swal.close();
                        if (response[0][0] == 'Actualizado') {

                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se actualizó el contacto con éxito.',
                                showConfirmButton: true,
                                // timer: 3000
                            }).then((result) => {
                                if (result.isConfirmed) {

                                }
                            })
                            this.validaTelefono = false;
                            this.limpiarCampos();
                            this.showAgregar = false;
                            this.valagregar = true;
                            this.showEditar = true;

                            this.actores.staid = '';
                            this.tipotelf.sttid = '';
                            this.numtelf = '';
                            this.errorTelf = [];


                            Detalle.Telefonos(this).then(datostel => {
                                this.telefonos = datostel;
                            });



                        }
                        else if (response[0][0] == 'El número de teléfono ya existe.') {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: response[0][0],
                                showConfirmButton: true
                            })
                            this.disabledSave = false;
                            this.numtelf = '';
                        }



                    });

                }
                else {
                    this.disabledSave = false;
                    this.validaTelefono = true;
                }



            } else {
                this.disabledSave = false;
                if (this.actores.staid == '') {
                    this.validaActor = true;
                }
                if (this.tipotelf.sttid == '') {
                    this.validaTipo = true;
                }
                if (this.phone.valid == false && this.$refs.form1.validate()) {
                    this.errorTelf.push("Teléfono Inválido");
                }


            }





        },
        agregarTelf() {
            this.telefonos.forEach((value, index) => {
                this.telefonos[index].showEditar = 0;
            });
            this.validaTelefono = false;
            this.errorTelf = [];
            this.showAgregar = true;
            this.valagregar = false;
        },
        cancelarEdicion(item, index) {
            this.validaTelefono = false;
            this.telefonos[index].showEditar = 0;
            this.valagregar = true;
            this.actores.staid = '';
            this.tipotelf.sttid = '';
            this.numtelf = '';
            this.showEditar = true;
            this.errorTelf = [];
            //this.$refs.form1.reset();
            this.validaActor = false;
            this.validaTipo = false;
        },
        editaTelf(item, index) {
            this.validaTelefono = false;
            this.showEditar = false;
            this.telefonos.forEach((value, index) => {
                this.telefonos[index].showEditar = 0;
            });
            this.errorTelf = [];
            this.validaActor = false;
            this.validaTipo = false;
            this.telefonos[index].showEditar = 1;
            this.valagregar = false;
            this.actores.staid = { staid: this.telefonos[index].staid, stadescripcion: this.telefonos[index].stadescripcion };
            this.tipotelf.sttid = { sttid: this.telefonos[index].sttid, sttdescripcion: this.telefonos[index].sttdescripcion };
            this.numtelf = this.telefonos[index].stnumero2;
        },

        guardarAlta() {
            this.disabledSave = true;
            this.$refs.form.validate();
            if (this.actores.staid != '' && this.tipotelf.sttid != '' && this.$refs.form.validate() && this.prefijo != '' && this.phone.valid == true) {
                const stringWithoutNumbers = this.phone.number.replace(/[^0-9]+/g, "");
                this.numtelf2 = stringWithoutNumbers;

                this.$swal({
                    position: 'center',
                    title: 'Guardando Contacto, espere un momento....',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });
                Detalle.altaContacto(this).then(response => {



                    this.$swal.close();
                    if (response[0][0] == '') {

                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se guardó el contacto con éxito.',
                            showConfirmButton: true,
                            // timer: 3000
                        }).then((result) => {
                            if (result.isConfirmed) {

                            }
                        })
                        this.limpiarCampos();
                        this.showAgregar = false;
                        this.valagregar = true;
                        this.errorTelf = [];
                        Detalle.Telefonos(this).then(datostel => {
                            this.telefonos = datostel;
                        });



                    }
                    else if (response[0][0] == 'El número de teléfono ya existe.') {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: response[0][0],
                            showConfirmButton: true
                        })
                        this.disabledSave = false;
                        this.numtelf = '';
                    }
                    else if (response[0][0] == 'El número de teléfono es de Ausa.') {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: response[0][0],
                            showConfirmButton: true
                            // timer: 3000
                        })
                        this.disabledSave = false;
                        this.numtelf = '';
                    }



                });





            } else {
                this.disabledSave = false;
                if (this.actores.staid == '') {
                    this.validaActor = true;
                }
                if (this.tipotelf.sttid == '') {
                    this.validaTipo = true;
                }
                if (this.phone.valid == false && this.$refs.form.validate()) {
                    this.errorTelf.push("Teléfono Inválido");
                }


            }

        },
        cancelarAlta() {
            this.validaTelefono = false;
            this.showAgregar = false;
            this.valagregar = true;
            this.errorTelf = [];
            //this.$refs.form.reset();
            this.validaActor = false;
            this.validaTipo = false;
            this.numtelf = "";
            this.actores.staid = "";
            this.tipotelf.sttid = "";

        },
        limpiarCampos() {
            this.validaTelefono = false;
            this.actores.staid = '';
            this.tipotelf.sttid = '';
            this.numtelf = '';
            this.numtelf2 = '';
            this.disabledSave = false;
            this.errorTelf = [];
        },
        eliminaTelf(item, index) {

            this.$swal({
                position: 'center',
                icon: 'warning',
                title: '¿Está seguro de eliminar el teléfono?',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonText: 'Eliminar',
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.$swal({
                        position: 'center',
                        title: 'Eliminando Contacto',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });

                    Detalle.eliminarContacto(this, item).then(response => {


                        setTimeout(() => {

                            this.$swal.close();
                            if (response) {

                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se eliminó el contacto con éxito.',
                                    showConfirmButton: true,
                                    // timer: 3000
                                }).then((result) => {
                                    if (result.isConfirmed) {

                                    }
                                })
                                Detalle.Telefonos(this).then(datostel => {
                                    this.telefonos = datostel;
                                });
                            }

                        }, 2000);


                    });
                }
            })

        },

        clickCitas() {

            this.$router.push({ name: 'citasGD' });
        },
        DatosDetalle() {
            Detalle.DatosDetalle(this).then(data => {
                console.log(data);
                let auxDetalleReporte = data[0];
                for (const [key, value] of Object.entries(auxDetalleReporte)) {
                    if (typeof value == "object") { auxDetalleReporte[key] = "" } else { auxDetalleReporte[key] = value.toString() }
                }
                this.detalleReporteData = auxDetalleReporte;
                this.svrobo = this.detalleReporteData.svrobo.toLowerCase() === 'true'
                this.svcolision = this.detalleReporteData.svcolision.toLowerCase() === 'true'
                this.svacredp = this.detalleReporteData.svacredp.toLowerCase() === 'true'
                this.svalcances = this.detalleReporteData.svalcances.toLowerCase() === 'true'
                this.svalcancecp = this.detalleReporteData.svalcancecp.toLowerCase() === 'true'
                this.svperdidadc = this.detalleReporteData.svperdidadc.toLowerCase() === 'true'

                Detalle.Telefonos(this).then(datostel => {
                    this.telefonos = []
                    this.telefonos = datostel;
                });

                Detalle.obtenerPermisoTelefonos(this).then(response => {

                    this.permisoTelf = response[0].Permiso;
                });

                Detalle.obtenerPermisoEdicion(this).then(response => {

                    this.permisoEdit = response[0].Permiso;
                });
                Detalle.obtenerPermisoIVR(this).then(response => {
                    if (response.upvalor != null) { this.permisoIVR = true }
                });

                Detalle.obtenerActores(this);
                Detalle.obtenerTiposTelf(this);


                this.show = false;
                //utils.addSinglesessionStorage(this.detalleReporteData.svnomcond + "-" + this.detalleReporteData.svemail, "aseg");
                sessionStorage.setItem('aseg', this.detalleReporteData.svnomcond + "-" + this.detalleReporteData.svemail);
                sessionStorage.setItem('asegName', this.detalleReporteData.svnomcond);
                //utils.addSinglesessionStorage(this.detalleReporteData.svfhconclusion,"svfhconclusion")

            })
        },
        async LlamadaIVR(telefono, tipo) {
            let actor = await Contacto.ObtenerTipoActor(this, telefono.stadescripcion);
            Detalle.LlamadaIVRServ(this, telefono.stnumero, actor).then(datostel => {
                if (datostel !== null) {
                    if (tipo == 1) {
                        window.location = 'tel:' + datostel;
                    } else {
                        MetodosGenerales.copiarTextoPlano(this, 'El IVR se copio en el portapapeles', 2000, datostel);
                    }

                }
            })
        },
    }
};
</script>
